import React from "react";
import { AiFillEye } from "react-icons/ai";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const PolicyHistory = () => {
  const { get_policy_cycle } = useSelector(
    (state) => state.policy?.customer_policy_details
  );

  return (
    <div className='mt-3'>
      <h5>Policy Cycle</h5>
      <div className=''>
        {get_policy_cycle?.length
          ? get_policy_cycle?.map((item, index) => (
              <Link
                to={`/admin/policy-history-cycle`}
                state={{
                  policyAppNumber: item?.policy_application_number,
                  customerId: item?.customer_id,
                  policy_cycle: item?.policy_cycle,
                }}
                className='d-flex justify-content-between align-items-center bg-white shadow gap-2 p-1 px-3 mb-2 text-primary cursor-p policy_circle '
                key={index}
              >
                <div>Policy cycle {item?.policy_cycle}</div>
                <AiFillEye className='text-primary' size={16} />
              </Link>
            ))
          : null}
      </div>
    </div>
  );
};

export default PolicyHistory;
